/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Logout_From_ApplicationInputs */

const en_logout_from_application = /** @type {(inputs: Logout_From_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logout from application`)
};

const fr_logout_from_application = /** @type {(inputs: Logout_From_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se déconnecter de l'application`)
};

const de_logout_from_application = /** @type {(inputs: Logout_From_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von der Anwendung abmelden`)
};

const it_logout_from_application = /** @type {(inputs: Logout_From_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disconnettersi dall'applicazione`)
};

const ru_logout_from_application = /** @type {(inputs: Logout_From_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выйти из приложения`)
};

const es_logout_from_application = /** @type {(inputs: Logout_From_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar sesión en la aplicación`)
};

const zh_cn2_logout_from_application = /** @type {(inputs: Logout_From_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从应用程序注销`)
};

const ja_logout_from_application = /** @type {(inputs: Logout_From_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アプリケーションからログアウト`)
};

const hi_logout_from_application = /** @type {(inputs: Logout_From_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एप्लिकेशन से लॉगआउट करें`)
};

const pt_pt2_logout_from_application = /** @type {(inputs: Logout_From_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair do aplicativo`)
};

/**
* | output |
* | --- |
* | "Logout from application" |
*
* @param {Logout_From_ApplicationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const logout_from_application = /** @type {((inputs?: Logout_From_ApplicationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logout_From_ApplicationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_logout_from_application(inputs)
	if (locale === "de") return de_logout_from_application(inputs)
	if (locale === "it") return it_logout_from_application(inputs)
	if (locale === "ru") return ru_logout_from_application(inputs)
	if (locale === "es") return es_logout_from_application(inputs)
	if (locale === "zh-CN") return zh_cn2_logout_from_application(inputs)
	if (locale === "ja") return ja_logout_from_application(inputs)
	if (locale === "hi") return hi_logout_from_application(inputs)
	if (locale === "pt-PT") return pt_pt2_logout_from_application(inputs)
	return en_logout_from_application(inputs)
});